<form [formGroup]="form">
  <rt-form-field margin-bottom>
    <rt-label>{{ t.companyName | translate }}</rt-label>
    <rt-input
      variant="rounded"
      [maxLength]="255"
      formControlName="companyName"
      placeholder=""
      [disabled]="isManual"
    >
    </rt-input>
  </rt-form-field>

  <rt-form-field margin-bottom>
    <rt-label>{{ t.country | translate }}</rt-label>
    <rt-select
      formControlName="countryCode"
      [disabled]="countries.length === 0 || isManual"
      [includeEmptyOption]="false"
      [items]="countries"
    ></rt-select>
  </rt-form-field>

  @if (form.contains('stateCode')) {
    <rt-form-field margin-bottom>
      <rt-label>{{ t.region | translate }}</rt-label>
      <rt-select
        formControlName="stateCode"
        [includeEmptyOption]="false"
        [items]="regions"
      ></rt-select>
    </rt-form-field>
  }

  <rt-form-field margin-bottom>
    <rt-label>{{ t.address | translate }}</rt-label>
    <rt-input variant="rounded" [maxLength]="255" formControlName="address" placeholder="">
    </rt-input>
  </rt-form-field>

  <div layout-space-between layout-horizontal>
    <rt-form-field margin-bottom margin-right>
      <rt-label>{{ t.city | translate }}</rt-label>
      <rt-input
        variant="rounded"
        [maxLength]="255"
        formControlName="city"
        placeholder=""
        width="100%"
      >
      </rt-input>
    </rt-form-field>

    <rt-form-field margin-bottom>
      <rt-label>{{ t.postalCode | translate }}</rt-label>
      <rt-input
        variant="rounded"
        [maxLength]="255"
        formControlName="postalCode"
        placeholder=""
        width="100%"
      >
      </rt-input>
    </rt-form-field>
  </div>

  @if (form.contains('vatNumber')) {
    <rt-form-field margin-bottom>
      <rt-label margin-bottom-small-xx>
        {{ t.vat | translate }}
        <rt-icon-help-with-dropdown
          [link]="t.vatSupportLink | translate"
          [infoText]="t.vatHint | translate"
          margin-left-small-x
        >
        </rt-icon-help-with-dropdown>
      </rt-label>
      <rt-input variant="rounded" formControlName="vatNumber" [disabled]="isManual"></rt-input>
    </rt-form-field>
  }
</form>
